export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_LtIt.fc04c28f.ttf";